import React, { Component } from 'react';
import classNames from 'classnames';
import OrderDetailsCard from './orderDetailsCard.jsx';
import OrderDetailsHeading from './orderDetailsHeading.jsx';
import OrderDetailsTotal from './orderDetailsTotal.jsx';
import PaymentDetails from '../account/paymentDetails.jsx';

export default ({
  currentPage, order, cards, showInfoSection, orderDetailsRow, activePanel,
  id, openSupportModal, openSupportCardLevelModal, openCancelSellOrderModal,
  toggleHelpOptions, orderSupportInfoCommon, showLocalSpinner, mostRecentOrder,
  orderType, status, date, userActions, toggleCardHelpButtons, renderCardHelpButtons,
  closeCardHelpButtons, openPaymentDetailsModal
}) => {

    const paymentMethod = order.requestedPaymentMethod;

    const ShowSpinner = () => {
      if (showLocalSpinner && activePanel === id) {
        return <div id="localLoader"></div>;;
      }
      return null;
    }

    let subTotal;
    let totalOfferAmount;
    let total;

    if (Object.keys(cards).length) {
      totalOfferAmount = cards.reduce((previousOfferAmount, currentCard) => {
        const faceValue = currentCard.faceValue && Object.keys(order.payments).length ? currentCard.faceValue : currentCard.enteredValue;
        const currentOfferAmount = (Number(currentCard.sellPercentage) / 100) * faceValue;
        return previousOfferAmount + Number(currentOfferAmount);
      }, 0);

      total = (totalOfferAmount) ? totalOfferAmount.toFixed(2) : '0.00'
    }

    return (
      <div>
        <div className={ ((activePanel === id) && Object.keys(order).length && cards.length) ? "animated fadeIn panel-selected" : "animated fadeOut" }>
          <table className="card-details-table-sell">
            <OrderDetailsHeading
              currentPage={currentPage}
              toggleHelpOptions={toggleHelpOptions}
              openSupportModal={openSupportModal}
              orderSupportInfoCommon={orderSupportInfoCommon}
              openSupportCardLevelModal={openSupportCardLevelModal}
              cards={cards}
              orderId={order.orderId}
              orderUUID={order.id}
              renderCardHelpButtons={renderCardHelpButtons}
              userActions={userActions}
            />
            { Object.keys(order).length && cards.length
              ? (
                cards.map((card, key) => {
                  return (
                    <OrderDetailsCard
                      currentPage={currentPage}
                      card={card}
                      order={order}
                      payments={order.payments}
                      openSupportCardLevelModal={openSupportCardLevelModal}
                      orderSupportInfoCommon={orderSupportInfoCommon}
                      renderCardHelpButtons={renderCardHelpButtons}
                      key={key}
                    />
                  )
                })
              ) : <ShowSpinner />
            }
          </table>
          <OrderDetailsTotal
            paymentMethod={paymentMethod}
            subTotal={ subTotal ? subTotal.toFixed(2) : '0.00' }
            total={total}
          />
        { order.payments && order.payments.length > 0 && (
          <PaymentDetails
            payments={order.payments}
            openPaymentDetailsModal={openPaymentDetailsModal}
          />
        )}
        </div>
      </div>
    );
}
